<template>
  <component
    :is="type"
    v-b-modal="`validation-modal-${id}`"
    :disabled="disabled"
    :variant="variant"
    v-bind="$attrs"
  >
    <slot id="label">
      <b-spinner v-if="loading" small :class="{ 'mr-2': showButtonLabel }" />
      <b-icon v-else-if="icon" :class="{ 'mr-2': showButtonLabel }" :icon="icon" /><span
        v-if="showButtonLabel"
        >{{ capitalize(label) }}</span
      >
    </slot>
    <b-modal
      :id="`validation-modal-${id}`"
      ref="modal"
      centered
      :ok-title="capitalize(label ? label : $t('forms.yes'))"
      :cancel-title="capitalize($t('forms.cancel'))"
      button-size="sm"
      hide-header
      :ok-variant="variant"
      cancel-variant="outline-secondary"
      @ok="performAction"
      @hidden="$emit('hidden')"
    >
      <slot name="question" :hide="() => $refs.modal.hide()">
        {{ question }}
      </slot>
    </b-modal>
  </component>
</template>

<script>
import { capitalize } from "@/helpers/filters";

let id = 0;
export default {
  name: "ValidatedButton",
  props: {
    question: {
      type: String,
      default: "",
    },
    action: {
      type: Function,
      default: async () => {},
    },
    icon: {
      type: String,
      default: undefined,
    },
    variant: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "b-button",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showButtonLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // This is needed in case there are more than one modal with the same name, to avoid all of
      // them opening at the same time.
      id: id++,
      loading: false,
    };
  },
  methods: {
    capitalize,
    async performAction() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      try {
        await this.action();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
